// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackCustomerChangedParameters
    extends TrackEventBaseParameters<null, "fulfillment_method" | "set_as_default"> {}

const trackCustomerChanged = (
    parameters: TrackCustomerChangedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "customer_changed", ...parameters }, options);
};

export default trackCustomerChanged;
